// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';

const DealerHierarchyAccount = props =>
    <li>
        <FormattedMessage
            id='DEALER_HIERARCHY_ACCOUNT'
            values={{
                account: props.account.account,
                industryIndicator: props.account.industryIndicator
            }}
        >
            {formattedMessage =>
                <Checkbox
                    id={props.id}
                    onChange={props.onAccountChange}
                    selected={props.selectedAccounts[props.account.account]}
                >
                    {formattedMessage}
                </Checkbox>
            }
        </FormattedMessage>
    </li>;

DealerHierarchyAccount.displayName = 'DealerHierarchyAccount';
DealerHierarchyAccount.propTypes = {
    account: PropTypes.shape({
        account: PropTypes.string,
        industryIndicator: PropTypes.string
    }).isRequired,
    id: PropTypes.string.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.object
};

export default DealerHierarchyAccount;



// WEBPACK FOOTER //
// ./src/shared/components/facets/dealer-hierarchy/dealer-hierarchy-account.js